import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import { grey, yellow } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import React from "react";

const StoreFormFeatureCheckbox = withStyles(
  {
    checked: {},
    root: {
      "&$checked": {
        color: yellow[600]
      },
      color: grey[400]
    }
  },
  { name: "StoreFormFeatureCheckbox" }
)((props: CheckboxProps) => <Checkbox color="default" {...props} />);

export default StoreFormFeatureCheckbox;
